import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './QuickLink.css';

const QuickLink = () => {
  const [isMinimized, setIsMinimized] = useState(false);
  const navigate = useNavigate();
  const { language } = useLanguage();

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const handleMenuClick = (path) => {
    // 언어에 따라 경로 설정
    const languagePath = language === 'en' ? `/en${path}` : path;
    navigate(languagePath);
  };

  // 온라인 견적 섹션으로 이동하는 함수
  const scrollToOnlineQuote = () => {
    const currentPath = window.location.pathname;
    const targetPath = language === 'en' ? `/en/customer-support` : `/ko/customer-support`;
    
    if (currentPath === targetPath) {
      // 같은 페이지에 있으면 바로 스크롤
      const scrollToElement = () => {
        const element = document.getElementById('online-quote');
        if (element) {
          const headerHeight = 100; // 헤더 높이
          const elementPosition = element.offsetTop - headerHeight - 30; // 헤더 높이 + 여백
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        } else {
          // 요소가 아직 로드되지 않았다면 다시 시도
          setTimeout(scrollToElement, 100);
        }
      };
      scrollToElement();
    } else {
      // 다른 페이지면 페이지 이동 후 스크롤
      navigate(targetPath);
      
      // 페이지 이동 후 여러 번 시도하여 확실하게 스크롤
      const attemptScroll = (attempts = 0) => {
        setTimeout(() => {
          const element = document.getElementById('online-quote');
          if (element) {
            const headerHeight = 100; // 헤더 높이
            const elementPosition = element.offsetTop - headerHeight - 30; // 헤더 높이 + 여백
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          } else if (attempts < 10) {
            // 최대 10번까지 시도 (2초간)
            attemptScroll(attempts + 1);
          }
        }, 200);
      };
      attemptScroll();
    }
  };


  // 언어별 텍스트
  const texts = {
    ko: {
      title: 'QUICK MENU',
      onlineQuote: '온라인견적',
      eProcurement: '전자구매',
      customerCenter: '고객센터'
    },
    en: {
      title: 'QUICK MENU',
      onlineQuote: 'Online Quote',
      eProcurement: 'E-Procurement',
      customerCenter: 'Customer Center'
    }
  };

  const currentTexts = texts[language] || texts.ko;

  return (
    <div className={`quick-link ${isMinimized ? 'minimized' : ''}`}>
      <div className="quick-link-header">
        <span className="menu-title">{currentTexts.title}</span>
        <button className="minimize-button" onClick={toggleMinimize}>
          <span>{isMinimized ? '+' : '−'}</span>
        </button>
      </div>
      
      {!isMinimized && (
        <div className="quick-link-items">
          <div className="quick-link-item" onClick={scrollToOnlineQuote}>
            <div className="quick-link-icon">
              🖱️
            </div>
            <span className="quick-link-text">{currentTexts.onlineQuote}</span>
            <div className="arrow-icon">▶</div>
          </div>

          <div className="quick-link-item" onClick={() => handleMenuClick('/e-procurement')}>
            <div className="quick-link-icon">
              🛒
            </div>
            <span className="quick-link-text">{currentTexts.eProcurement}</span>
            <div className="arrow-icon">▶</div>
          </div>

          <div className="quick-link-item" onClick={() => handleMenuClick('/customer-support')}>
            <div className="quick-link-icon">
              📞
            </div>
            <span className="quick-link-text">{currentTexts.customerCenter}</span>
            <div className="arrow-icon">▶</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickLink;
